import { render, staticRenderFns } from "./EditFarmForm.vue?vue&type=template&id=dc0bf58a&"
import script from "./EditFarmForm.vue?vue&type=script&lang=ts&"
export * from "./EditFarmForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports